export default "__VITE_ASSET__Djo4EFTZ__"